import { render } from "./loading.vue?vue&type=template&id=575c2eb5"
import script from "./loading.vue?vue&type=script&lang=js"
export * from "./loading.vue?vue&type=script&lang=js"
script.render = render

export default script